import React from 'react';
import MeetShannon from '../components/MeetShannon';
import Difference from '../components/Difference';

const About = () => {
  return (
    <div>
      <MeetShannon />
      <Difference />
    </div>
  );
};

export default About;
